import { Dictionary } from 'lodash';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useLoggedInUserRoles } from '~/components/Auth';
import { updateCompanyPreferences } from '~/data/companyPreferences/index';
import { CompanyPreferencesApiClient, IAm } from '~/services/Http';
import { isRoleHRAdminFull } from '~/services/Permissions';

export const useUpdateCompanyPreferences = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const myRoles = useLoggedInUserRoles();
  const isHRAdmin = isRoleHRAdminFull(myRoles);

  return useCallback(
    (partialCompanySettings: Dictionary<object>) => {
      // Only Full HR Admin can update
      if (isHRAdmin) {
        // TODO: Throttle cases of no-change API calls
        CompanyPreferencesApiClient.setCompanyPreferences(
          IAm.CompanyPreferencesInputDto.fromJS({
            data: partialCompanySettings,
          }),
        )
          .then(() => {
            dispatch(updateCompanyPreferences(partialCompanySettings));
            // TODO: Enable snackbar message when API is called only on actual change
            // enqueueSnackbar(t('change_saved'), {
            //   variant: 'success',
            // });
          })
          .catch((err) => {
            console.error(err);
            enqueueSnackbar(t('errorMsg'), {
              variant: 'error',
            });
          });
      }
    },
    [isHRAdmin, dispatch, enqueueSnackbar, t],
  );
};
